import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HomePage.scss";

import HomeHeader from "./components/HomeHeader";
import WaitlistModal from "./components/WaitlistModal";
import Hero from "./sections/Hero";
import People from "./sections/People";
import Tools from "./sections/Tools";
import OcMinds from "./sections/OcMinds";
import Ecosystem from "./sections/Ecosystem";
import Markets from "./sections/Markets";
import Partners from "./sections/Partners";
import Faq from "./sections/Faq";
import Cta from "./sections/Cta";
import Footer from "./sections/Footer";

/** Path deep links that open a waitlist modal (QR / campaign URLs). */
const WAITLIST_PATHS = {
  "/ai-fast-track-waitlist": "fastTrack",
  "/open-campus-web-app-waitlist": "minds",
};

export const HomePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [waitlistVariant, setWaitlistVariant] = useState(null);

  // Open the matching waitlist modal for /ai-fast-track-waitlist or
  // /open-campus-web-app-waitlist.
  useEffect(() => {
    const variant = WAITLIST_PATHS[location.pathname];
    if (variant) setWaitlistVariant(variant);
  }, [location.pathname]);

  const closeWaitlist = () => {
    setWaitlistVariant(null);
    if (WAITLIST_PATHS[location.pathname]) {
      navigate("/", { replace: true });
    }
  };

  // When the homepage is opened with a section hash (e.g. arriving from the
  // header on /oc-achievements via "/#community"), scroll to that section once
  // it's laid out. Skip waitlist paths — those open a modal instead.
  useEffect(() => {
    if (WAITLIST_PATHS[location.pathname]) return undefined;
    const hash = window.location.hash;
    if (!hash) return undefined;
    const t = window.setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 400);
    return () => window.clearTimeout(t);
  }, [location.pathname]);

  return (
    <div className="oc-home">
      <HomeHeader />
      <Hero />
      <People />
      <Tools />
      <OcMinds />
      <Ecosystem />
      <Markets />
      <Partners />
      <Faq />
      <Cta />
      <Footer />

      <WaitlistModal
        open={!!waitlistVariant}
        onClose={closeWaitlist}
        variant={waitlistVariant || "fastTrack"}
      />
    </div>
  );
};

export default HomePage;
